/* eslint-disable */

/** unique or primary key constraints on table "process.collection" */
export enum ProcessCollectionConstraint {
  /** unique or primary key constraint on columns "collection_id" */
  CollectionPkey = 'collection_pkey'
}

/** unique or primary key constraints on table "process.collection_data" */
export enum ProcessCollectionDataConstraint {
  /** unique or primary key constraint on columns "data_element_id", "collection_id" */
  CollectionDataPkey = 'collection_data_pkey'
}

/** select columns of table "process.collection_data" */
export enum ProcessCollectionDataSelectColumn {
  /** column name */
  BoolVal = 'bool_val',
  /** column name */
  CollectedValue = 'collected_value',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val'
}

/** select "process_collection_data_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.collection_data" */
export enum ProcessCollectionDataSelectColumnProcessCollectionDataAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  BoolVal = 'bool_val'
}

/** select "process_collection_data_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.collection_data" */
export enum ProcessCollectionDataSelectColumnProcessCollectionDataAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  BoolVal = 'bool_val'
}

/** update columns of table "process.collection_data" */
export enum ProcessCollectionDataUpdateColumn {
  /** column name */
  BoolVal = 'bool_val',
  /** column name */
  CollectedValue = 'collected_value',
  /** column name */
  CollectionId = 'collection_id',
  /** column name */
  DataElementId = 'data_element_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumVal = 'num_val',
  /** column name */
  StrVal = 'str_val'
}

/** unique or primary key constraints on table "process.collection_kind" */
export enum ProcessCollectionKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  CollectionKindPkey = 'collection_kind_pkey'
}

export enum ProcessCollectionKindEnum {
  /** A value is provided during collection */
  Collect = 'collect',
  /** The value is provided by the process */
  SpecParam = 'spec_param'
}

/** select columns of table "process.collection_kind" */
export enum ProcessCollectionKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** update columns of table "process.collection_kind" */
export enum ProcessCollectionKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** select columns of table "process.collection" */
export enum ProcessCollectionSelectColumn {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailureNote = 'failure_note',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialStateId = 'material_state_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Pass = 'pass',
  /** column name */
  SpecId = 'spec_id'
}

/** select "process_collection_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.collection" */
export enum ProcessCollectionSelectColumnProcessCollectionAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Pass = 'pass'
}

/** select "process_collection_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.collection" */
export enum ProcessCollectionSelectColumnProcessCollectionAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Pass = 'pass'
}

/** update columns of table "process.collection" */
export enum ProcessCollectionUpdateColumn {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailureNote = 'failure_note',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialStateId = 'material_state_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Pass = 'pass',
  /** column name */
  SpecId = 'spec_id'
}

/** unique or primary key constraints on table "process.data_element_collection_kind" */
export enum ProcessDataElementCollectionKindConstraint {
  /** unique or primary key constraint on columns "collection_kind" */
  DataElementCollectionKindPkey = 'data_element_collection_kind_pkey'
}

export enum ProcessDataElementCollectionKindEnum {
  /** A value is provided after a collection */
  Calc = 'calc',
  /** A value is provided during collection */
  Collect = 'collect',
  /** The value is provided by the process */
  SpecParam = 'spec_param'
}

/** select columns of table "process.data_element_collection_kind" */
export enum ProcessDataElementCollectionKindSelectColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  Description = 'description'
}

/** update columns of table "process.data_element_collection_kind" */
export enum ProcessDataElementCollectionKindUpdateColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  Description = 'description'
}

/** unique or primary key constraints on table "process.data_element" */
export enum ProcessDataElementConstraint {
  /** unique or primary key constraint on columns "data_element_id" */
  DataElementPkey = 'data_element_pkey'
}

/** unique or primary key constraints on table "process.data_element_kind" */
export enum ProcessDataElementKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  DataElementKindPkey = 'data_element_kind_pkey'
}

export enum ProcessDataElementKindEnum {
  /** A true / false representation of data */
  Boolean = 'boolean',
  /** A Material */
  Material = 'material',
  /** A Material Class */
  MaterialClass = 'material_class',
  /** A Material Model */
  MaterialModel = 'material_model',
  /** A numeric representation of data */
  Number = 'number',
  /** A textual representation of data */
  String = 'string'
}

/** select columns of table "process.data_element_kind" */
export enum ProcessDataElementKindSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** update columns of table "process.data_element_kind" */
export enum ProcessDataElementKindUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Kind = 'kind'
}

/** select columns of table "process.data_element" */
export enum ProcessDataElementSelectColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UomId = 'uom_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "process_data_element_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.data_element" */
export enum ProcessDataElementSelectColumnProcessDataElementAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "process_data_element_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.data_element" */
export enum ProcessDataElementSelectColumnProcessDataElementAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "process.data_element" */
export enum ProcessDataElementUpdateColumn {
  /** column name */
  CollectionKind = 'collection_kind',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UomId = 'uom_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** unique or primary key constraints on table "process.material_state" */
export enum ProcessMaterialStateConstraint {
  /** unique or primary key constraint on columns "material_id", "process_id" */
  EnforceOnlyOneProcessPerMaterial = 'enforce_only_one_process_per_material',
  /** unique or primary key constraint on columns "material_state_id" */
  MaterialStatePkey = 'material_state_pkey'
}

/** unique or primary key constraints on table "process.material_state_history" */
export enum ProcessMaterialStateHistoryConstraint {
  /** unique or primary key constraint on columns "material_state_history_id" */
  MaterialStateHistoryPkey = 'material_state_history_pkey'
}

/** select columns of table "process.material_state_history" */
export enum ProcessMaterialStateHistorySelectColumn {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialStateHistoryId = 'material_state_history_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status'
}

/** update columns of table "process.material_state_history" */
export enum ProcessMaterialStateHistoryUpdateColumn {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  MaterialStateHistoryId = 'material_state_history_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status'
}

/** select columns of table "process.material_state" */
export enum ProcessMaterialStateSelectColumn {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecConfig = 'spec_config',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "process.material_state" */
export enum ProcessMaterialStateUpdateColumn {
  /** column name */
  Attempt = 'attempt',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FailCount = 'fail_count',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PassCount = 'pass_count',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  Reason = 'reason',
  /** column name */
  SpecConfig = 'spec_config',
  /** column name */
  SpecId = 'spec_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** unique or primary key constraints on table "process.process" */
export enum ProcessProcessConstraint {
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  ProcessEnforceUniqueName = 'process_enforce_unique_name',
  /** unique or primary key constraint on columns "process_id" */
  ProcessPkey = 'process_pkey'
}

/** select columns of table "process.process" */
export enum ProcessProcessSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** unique or primary key constraints on table "process.process_status" */
export enum ProcessProcessStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ProcessStatusPkey = 'process_status_pkey'
}

export enum ProcessProcessStatusEnum {
  /** Completed */
  Completed = 'completed',
  /** Failed */
  Failed = 'failed',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Manually Completed */
  ManuallyCompleted = 'manually_completed',
  /** Not Required */
  NotRequired = 'not_required'
}

/** select columns of table "process.process_status" */
export enum ProcessProcessStatusSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** update columns of table "process.process_status" */
export enum ProcessProcessStatusUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Status = 'status'
}

/** update columns of table "process.process" */
export enum ProcessProcessUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** unique or primary key constraints on table "process.spec" */
export enum ProcessSpecConstraint {
  /** unique or primary key constraint on columns "context_id", "process_id", "name_unique" */
  SpecEnforceUniqueName = 'spec_enforce_unique_name',
  /** unique or primary key constraint on columns "spec_id" */
  SpecPkey = 'spec_pkey'
}

/** unique or primary key constraints on table "process.spec_order" */
export enum ProcessSpecOrderConstraint {
  /** unique or primary key constraint on columns "spec_order_id" */
  SpecOrderPkey = 'spec_order_pkey'
}

/** select columns of table "process.spec_order" */
export enum ProcessSpecOrderSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DefaultSpecIds = 'default_spec_ids',
  /** column name */
  Id = 'id',
  /** column name */
  NonDefaultSpecIds = 'non_default_spec_ids',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeStart = 'time_start'
}

/** update columns of table "process.spec_order" */
export enum ProcessSpecOrderUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  DefaultSpecIds = 'default_spec_ids',
  /** column name */
  Id = 'id',
  /** column name */
  NonDefaultSpecIds = 'non_default_spec_ids',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeStart = 'time_start'
}

/** select columns of table "process.spec" */
export enum ProcessSpecSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Locked = 'locked',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentSpecId = 'parent_spec_id',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeEnd = 'time_end',
  /** column name */
  TimeStart = 'time_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "process_spec_aggregate_bool_exp_bool_and_arguments_columns" columns of table "process.spec" */
export enum ProcessSpecSelectColumnProcessSpecAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Locked = 'locked'
}

/** select "process_spec_aggregate_bool_exp_bool_or_arguments_columns" columns of table "process.spec" */
export enum ProcessSpecSelectColumnProcessSpecAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Locked = 'locked'
}

/** update columns of table "process.spec" */
export enum ProcessSpecUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ConfigEditable = 'config_editable',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  History = 'history',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  Locked = 'locked',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  ParentSpecId = 'parent_spec_id',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  TimeEnd = 'time_end',
  /** column name */
  TimeStart = 'time_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

